import { css, StyleSheet } from 'aphrodite';
import { InputHTMLAttributes } from 'react';
import { FieldError } from 'react-hook-form';
import { Row } from '../../../../components/Layout';
import { styleSheet } from '../../../../components/blogs/styles';
import { FontSizeInput } from './FontSizeInput';

interface ResponsiveFontSizeInputsProps {
	desktopError?: FieldError;
	desktopInputProps: InputHTMLAttributes<HTMLInputElement>;
	desktopLabel: string;
	max: number;
	min: number;
	mobileError?: FieldError;
	mobileInputProps: InputHTMLAttributes<HTMLInputElement>;
	mobileLabel: string;
	step?: number;
}

export const ResponsiveFontSizeInputs = ({
	desktopError,
	desktopInputProps,
	desktopLabel,
	max,
	min,
	mobileError,
	mobileInputProps,
	mobileLabel,
	step = 1,
}: ResponsiveFontSizeInputsProps) => {
	return (
		<Row className={css(styleSheet.gap12)}>
			<div className={css(responsiveFontSizeInputStyleSheet.item)}>
				<FontSizeInput
					error={desktopError}
					label={desktopLabel}
					max={max}
					min={min}
					step={step}
					{...desktopInputProps}
				/>
			</div>
			<div className={css(responsiveFontSizeInputStyleSheet.item)}>
				<FontSizeInput error={mobileError} label={mobileLabel} max={max} min={min} step={step} {...mobileInputProps} />
			</div>
		</Row>
	);
};

const responsiveFontSizeInputStyleSheet = StyleSheet.create({
	item: {
		flex: 1,
		minWidth: 0,
	},
});
